import React, {Component, ReactElement, ReactNode} from 'react'
import {
    ADMINISTORATOR_MODE,
    EVENT_CATEGORY,
    EVENT_ITEM_CLEANING,
    EVENT_ITEM_GARBAGE_DAY,
    EVENT_ITEM_MAINTENANCE,
    EVENT_ITEM_OTHER,
    EVENT_ITEM_OTHER_EVENTS,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    VALID_OR_NOT,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate';
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons';
import {BackLink} from '../../../styledComponents/adminPage/Links';
import {formatDateZeroPadding, formatForDateInput} from '../../../formatters/formatDate';
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material';
import NatScheduleRepo from '../schedule/repository/NatScheduleRepo';
import {NatGetSchedule, ScheduleNotDeliveryCondominiumList} from '../schedule/repository/NatGetSchedule';
import NatEventRepo from '../event/repository/NatEventRepo';
import {NatGetEvent} from './repository/NatGetEvent';
import PPDatePicker from '../../../components/shared/forms/PPDatePicker';
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup';
import {Messages} from '../../../Messages';
import {NatPutEvent, PutEventInfo} from './repository/NatPutEvent';
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent';
import {getScheduleSettingInfo} from '../../common/util/Natutil';
import styled from 'styled-components';
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition as SearchConditionList,
    SearchConditionPageInfo as CondominiumSearchConditionPageInfo
} from '../condominium/repository/NatGetCondominiumList'
import {SearchConditionPageInfo} from './repository/NatGetEventList'
import {SortOrder} from '../../../components/shared/SortOrder'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    scheduleId: string
    seq: string
    scheduleRepo: NatScheduleRepo
    eventRepo: NatEventRepo
    eventEmitter: EventEmitterExAdmin
    condominiumRepo: NatCondominiumRepo
    location: Location<LocationState>
}

interface States {
    schedule: NatGetSchedule
    scheduleTitle: string
    eventCategory: string
    eventItem: string
    scheduleTermDate: string
    description: string
    scheduleSetting: string
    condominiumName: string,
    condominiumGroupName: string,
    scheduleNotDeliveryCondominium: ScheduleNotDeliveryCondominiumList[],
    deliveryTargetPrefectureCd: string,
    deliveryTargetAddress2: string,
    scheduleDeliveryTargetCondominiumList: CondominiumInfo[],
    scheduleAssignDate: string
    operationDateMin: string
    operationDateMax: string
    operationDate: string
    invisible: string
    version: number
    isLoadCompleted: boolean
}


class NatAdminEventEditPage extends Component<Props & AdminPagePropsSet, States> {
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)

        this.state = {
            schedule: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            scheduleTitle: '',
            eventCategory: '',
            eventItem: '',
            scheduleTermDate: '',
            description: '',
            scheduleSetting: '',
            scheduleNotDeliveryCondominium: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            scheduleDeliveryTargetCondominiumList: [],
            condominiumName: '',
            condominiumGroupName: '',
            scheduleAssignDate: '',
            operationDateMin: '',
            operationDateMax: '',
            operationDate: '',
            invisible: '',
            version: 0,
            isLoadCompleted: false,
        }
        this.backEventLinkClick = this.backEventLinkClick.bind(this)
        this.editEventLinkClick = this.editEventLinkClick.bind(this)
        this.handleEditCancelClick = this.handleEditCancelClick.bind(this)
        this.handleEditOkClick = this.handleEditOkClick.bind(this)
        this.showInitialMessage = this.showInitialMessage.bind(this)
        this.onChangeOperationDate = this.onChangeOperationDate.bind(this)
        this.onChangeInvisible = this.onChangeInvisible.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // スケジュール取得
            const schedule: Nullable<NatGetSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.getSchedule.bind(this.props.scheduleRepo, this.props.scheduleId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            // イベント取得
            const event: Nullable<NatGetEvent> = await this.props.asyncCallFunction(
                this.props.eventRepo.getEvent.bind(this.props.scheduleRepo, this.props.scheduleId, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (schedule && schedule.details &&
                event && event.details) {
                // イベントカテゴリ
                const eventCategoryMaster = EVENT_CATEGORY.codeToEnumConstants(schedule.details.eventCategory)
                let eventCategory: string = ''
                if (eventCategoryMaster) {
                    eventCategory = eventCategoryMaster.label
                }
                // イベント項目
                let eventItem: string = ''
                switch (schedule.details.eventCategory) {
                    case EVENT_CATEGORY.TRASH_DAY.value:
                        const garbageMaster =
                            EVENT_ITEM_GARBAGE_DAY.codeToEnumConstants(schedule.details.eventItem)
                        if (garbageMaster) {
                            eventItem = garbageMaster.label
                        }
                        break
                    case EVENT_CATEGORY.MAINTENANCE.value:
                        const maintenanceMaster =
                            EVENT_ITEM_MAINTENANCE.codeToEnumConstants(schedule.details.eventItem)
                        if (maintenanceMaster) {
                            eventItem = maintenanceMaster.label
                        }
                        break
                    case EVENT_CATEGORY.CLEANING.value:
                        const cleaningMaster =
                            EVENT_ITEM_CLEANING.codeToEnumConstants(schedule.details.eventItem)
                        if (cleaningMaster) {
                            eventItem = cleaningMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER_EVENT.value:
                        const otherEventsMaster =
                            EVENT_ITEM_OTHER_EVENTS.codeToEnumConstants(schedule.details.eventItem)
                        if (otherEventsMaster) {
                            eventItem = otherEventsMaster.label
                        }
                        break
                    case EVENT_CATEGORY.OTHER.value:
                        const otherMaster =
                            EVENT_ITEM_OTHER.codeToEnumConstants(schedule.details.eventItem)
                        if (otherMaster) {
                            eventItem = otherMaster.label
                        }
                        break
                    default:
                        break
                }
                // 実施期間
                let scheduleTermDate: string = ''
                if (!schedule.details.scheduleEndDate) {
                    scheduleTermDate = formatDateZeroPadding(schedule.details.scheduleStartDate)
                } else {
                    scheduleTermDate = `${formatDateZeroPadding(schedule.details.scheduleStartDate)}から
                    ${formatDateZeroPadding(schedule.details.scheduleEndDate)}まで`
                }

                ReactDOM.flushSync(() => {
                    if (schedule && schedule.details &&
                        event && event.details) {
                        this.setState({
                            schedule: schedule,
                            scheduleTitle: schedule.details.title,
                            eventCategory: eventCategory,
                            eventItem: eventItem,
                            scheduleTermDate: scheduleTermDate,
                            description: schedule.details.description,
                            scheduleSetting: getScheduleSettingInfo(
                                schedule.details.repeatDate,
                                schedule.details.repeatWeekUnit,
                                schedule.details.repeatWeek,
                                schedule.details.repeatDayOfWeek),
                            condominiumName: schedule.details.condominiumName,
                            condominiumGroupName: schedule.details.condominiumGroupName,
                            scheduleNotDeliveryCondominium: schedule.details.scheduleNotDeliveryCondominium,
                            deliveryTargetPrefectureCd: schedule.details.deliveryTargetPrefectureCd ?
                                schedule.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: schedule.details.deliveryTargetAddress2 ?
                                schedule.details.deliveryTargetAddress2 : '',
                            scheduleAssignDate: event.details.scheduleAssignDate,
                            operationDateMin: schedule.details.scheduleStartDate,
                            operationDateMax: (schedule.details.scheduleEndDate) ?
                                schedule.details.scheduleEndDate : schedule.details.scheduleStartDate,
                            operationDate: event.details.operationDate,
                            invisible: event.details.invisible,
                            version: event.details.version,
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    schedule.details.condominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

        this.showInitialMessage()
    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchConditionList = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                scheduleDeliveryTargetCondominiumList:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchConditionList,
        searchConditionPageInfo: CondominiumSearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    onChangeOperationDate(date: Nullable<Date>): void {
        if (date) {
            this.setState({operationDate: date.toString()})
        } else {
            this.setState({operationDate: ''})
        }
    }

    onChangeInvisible(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            invisible: (this.state.invisible === VALID_OR_NOT.VALID.value) ?
                VALID_OR_NOT.NOT.value : VALID_OR_NOT.VALID.value,
        })
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    backEventLinkClick(): void {
        this.props.navigate(`/admin/event/${this.props.scheduleId}/${this.props.seq}`)
    }

    async editEventLinkClick(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('イベント'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleEditCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleEditOkClick,
                    },
                ],
            },
        )
    }

    handleEditCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleEditOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const putEvent: PutEventInfo = {
                scheduleId: this.props.scheduleId,
                seq: this.props.seq,
                operationDate: this.state.operationDate ?
                    formatForDateInput(this.state.operationDate) : this.state.operationDate,
                invisible: this.state.invisible,
                versionEvent: String(this.state.version),
            }
            const putEventResponse: Nullable<NatPutEvent> = await this.props.asyncCallFunction(
                this.props.eventRepo.putEvent.bind(this.props.eventRepo, putEvent),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('イベント')},
            )
            if (putEventResponse && putEventResponse.requestError === null) {
                this.props.navigate(`/admin/event/${this.props.scheduleId}/${this.props.seq}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0008.toString('イベント'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderScheduleTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>スケジュール情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTitle}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>イベントカテゴリ</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventCategory}
                            </TableCell>
                            <TableRowName>イベント項目</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.eventItem}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>説明文</TableRowName>
                            <TableCellWordBreakAll colSpan={4}>
                                <div dangerouslySetInnerHTML={{__html: this.state.description}}/>
                            </TableCellWordBreakAll>
                        </TableRow>
                        <TableRow>
                            <TableRowName>実施期間</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleTermDate}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>設定内容</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.scheduleSetting}
                            </TableCell>
                        </TableRow>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName>対象グループ/物件</TableRowName>
                                    <TableCell colSpan={4}>
                                        {(this.state.condominiumName) ?
                                            this.state.condominiumName : this.state.condominiumGroupName}
                                    </TableCell>
                                </TableRow>
                                {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== '' ?
                                    <>
                                        <TableRow>
                                            <TableRowName>
                                                配信対象
                                            </TableRowName>
                                            <TableCell colSpan={4}>
                                                {`指定地域: ${this.getPrefectureName(this.state.deliveryTargetPrefectureCd)}
                                                ${this.state.deliveryTargetAddress2}`}
                                                {
                                                    <InnerMiniTable>
                                                        <InnerMiniTableBody>
                                                            {
                                                                this.state.scheduleDeliveryTargetCondominiumList.map(
                                                                    (condominiumInfo, index) => {
                                                                        return (
                                                                            <TableRow
                                                                                key={condominiumInfo.condominiumCd}>
                                                                                <InnerMiniTableCell>
                                                                                    {condominiumInfo.condominiumCd + ' ' +
                                                                                        condominiumInfo.condominiumName}
                                                                                </InnerMiniTableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                            }
                                                        </InnerMiniTableBody>
                                                    </InnerMiniTable>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    </>
                                    : <></>
                                }
                                <TableRow>
                                    <TableRowName>除外する物件</TableRowName>
                                    {this.state.scheduleNotDeliveryCondominium.map((scheduleNotDeliveryCondominium) => (
                                        <TableRow>
                                            <TableCell>
                                                {scheduleNotDeliveryCondominium.condominiumCd}
                                            </TableCell>
                                            <TableCell colSpan={3}>
                                                {scheduleNotDeliveryCondominium.condominiumName}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={(this.state.operationDate) ? false : true}
                        onClick={this.editEventLinkClick}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backEventLinkClick}
                    >
                        イベント詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }


    renderEventTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>イベント情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>実施日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                <PPDatePicker
                                    onChangeDate={this.onChangeOperationDate}
                                    value={(this.state.operationDate) ?
                                        new Date(this.state.operationDate) : null
                                    }
                                    minDate={(this.state.operationDateMin) ?
                                        new Date(this.state.operationDateMin) : null
                                    }
                                    maxDate={(this.state.operationDateMax) ?
                                        new Date(this.state.operationDateMax) : null
                                    }
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['operationDate']}
                                    autoFocus
                                />
                            </TableCell>
                            <TableRowName>スケジュール割り当て日</TableRowName>
                            <TableCell colSpan={2}>
                                {formatDateZeroPadding(this.state.scheduleAssignDate)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>非表示</TableRowName>
                            <TableCell colSpan={4}>
                                <PPCheckboxGroup
                                    data={[{
                                        label: '',
                                        checked: (VALID_OR_NOT.VALID.value === this.state.invisible),
                                    }]}
                                    eventKeys={['invisible']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.onChangeInvisible}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <Box mb={'15px'}>
                    <PageMainArea>
                        {this.renderScheduleTable()}
                    </PageMainArea>
                </Box>
                <PageMainArea>
                    {this.renderEventTable()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminEventEditPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
